import React from 'react'
import { Link } from 'react-router-dom'
import { Order } from '../../components/pagesComponents/order'
import { GeneralLoader } from '../../components/loaders/generalLoader'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useOrder } from '../../services/hooks/useOrder'
import { toast } from 'react-toastify'

import { Container, ContentLastUpdate, ContentHistory, Header, OrdersNotFound } from './style'

import { api } from '../../services/api'

export function Orders() {
    const { data, isLoading } = useOrder()



    const lastOrder = data?.lastOrder
    const genericDatas = data?.genericDatas



    ///Cancelando um pedido
    async function handleClickCancel(order){
        //console.log(order);
        if(order.statusList[0].current !== true){
            toast.error('Impossível de ser cancelado !!');
            return;
        }

        await api.post('/updateStatusOrder',{
            dsStatus:'R',
            idOrcamentos: [order.orderNumber],
            mensagemRejeicao: 'Pedido cancelado pelo cliente',
            isPgtOnline: order.statusList.length > 4 ?  true : false 
        })
        .then((response) => {
            //console.log(response);
            const {success, message} = response.data;

            if(success === 1){
                toast.success(message);
                //window.location.reload(true)
            }
            if(success === 0){
                throw new Error(message);
            }           

            ///Reinicia a página
            //document.location.reload(true);
        })
        .catch((error) => {
            //console.log(error)
            toast.error('Erro ao cancelar pedido');
        })
    }


    return (
        <Container>

            <Header>
                <Link to="/profile">
                    <AiOutlineArrowLeft />
                </Link>
                <h1>Meus pedidos</h1>
            </Header>

            {
                isLoading === false ?
                    <>
                    <ContentLastUpdate>
                        {lastOrder === undefined ?
                            <></>
                            :
                            <Order
                                nameBusiness={lastOrder.nameBusiness}
                                statusList={lastOrder.statusList}
                                orderNumber={lastOrder.orderNumber}
                                linkImage={lastOrder.linkImage}
                                products={lastOrder.products}
                                total={lastOrder.total}
                                minTimeDelivery={lastOrder.minTimeDelivery}
                                maxTimeDelivery={lastOrder.maxTimeDelivery}
                                noLine={true}
                                handleClickCancel={() => handleClickCancel(lastOrder)}
                            />
                        }
                    </ContentLastUpdate>

                    <ContentHistory>
                        <div className="historyLine">
                            <div />
                            <h2>Histórico</h2>
                            <div />
                        </div>

                        {
                            (genericDatas.length > 0) ?
                                genericDatas.map((order, index) => (
                                    <Order
                                        key={index}
                                        nameBusiness={order.nameBusiness}
                                        statusList={order.statusList}
                                        orderNumber={order.orderNumber}
                                        linkImage={order.linkImage}
                                        products={order.products}
                                        total={order.total}
                                        minTimeDelivery={order.minTimeDelivery}
                                        maxTimeDelivery={order.maxTimeDelivery}
                                        noLine={false}
                                        handleClickCancel={() => handleClickCancel(order)}
                                    />
                                )) 
                                : <OrdersNotFound>Nenhum pedido listado</OrdersNotFound>
                        }

                    </ContentHistory>
                    </>
            : 
                <GeneralLoader />
            }

        </Container>
    )
}